// Generated from shared/platform-registry.json. Do not edit by hand.

export const PLATFORM_MENU_DEFINITIONS = [
  {
    "key": "dashboard",
    "route": "/",
    "label": "Dashboard",
    "labelKey": "menu.dashboard.label",
    "subtitle": "Workspace KPIs and work queue",
    "icon": "LayoutDashboard",
    "minRole": "VIEWER"
  },
  {
    "key": "workspace",
    "route": "/workspaces",
    "label": "Workspaces",
    "labelKey": "menu.workspace.label",
    "subtitle": "Accounting workspace switching and member boundary",
    "subtitleKey": "menu.workspace.subtitle",
    "icon": "Building2",
    "minRole": "VIEWER"
  },
  {
    "key": "document-intake",
    "route": "/document-intake",
    "label": "Document Intake Inbox",
    "labelKey": "menu.documentIntake.label",
    "subtitle": "Receipt and invoice intake with AI parsing review",
    "subtitleKey": "menu.documentIntake.subtitle",
    "icon": "Inbox",
    "minRole": "VIEWER"
  },
  {
    "key": "document-summary",
    "route": "/document-summary",
    "label": "Voucher summary",
    "labelKey": "menu.documentSummary.label",
    "subtitle": "Approved voucher segments with finance filters and stats",
    "subtitleKey": "menu.documentSummary.subtitle",
    "icon": "BarChart3",
    "minRole": "VIEWER"
  },
  {
    "key": "accounting-books",
    "route": "/accounting/books",
    "label": "Accounting Book",
    "labelKey": "menu.accountingBooks.label",
    "subtitle": "Manage the workspace accounting book and periods",
    "subtitleKey": "menu.accountingBooks.subtitle",
    "icon": "BookOpen",
    "minRole": "VIEWER",
    "firstLaunch": false
  },
  {
    "key": "chart-of-accounts",
    "route": "/accounting/accounts",
    "label": "Chart of Accounts",
    "labelKey": "menu.chartOfAccounts.label",
    "subtitle": "Manage accounts for the active accounting book",
    "subtitleKey": "menu.chartOfAccounts.subtitle",
    "icon": "ListTree",
    "minRole": "VIEWER"
  },
  {
    "key": "ledger",
    "route": "/accounting/ledger",
    "label": "Ledger",
    "labelKey": "menu.ledger.label",
    "subtitle": "Posted journal ledger for the active accounting book",
    "subtitleKey": "menu.ledger.subtitle",
    "icon": "ScrollText",
    "minRole": "VIEWER",
    "firstLaunch": false
  },
  {
    "key": "review-inbox",
    "route": "/accounting/review-inbox",
    "label": "Review Inbox",
    "labelKey": "menu.reviewInbox.label",
    "subtitle": "Journal draft review requests waiting for action",
    "subtitleKey": "menu.reviewInbox.subtitle",
    "icon": "ClipboardCheck",
    "minRole": "VIEWER",
    "firstLaunch": false
  },
  {
    "key": "financial-reports",
    "route": "/financial-reports",
    "label": "Financial Reports",
    "labelKey": "menu.financialReports.label",
    "subtitle": "Trial balance, balance sheet, and profit and loss projections",
    "subtitleKey": "menu.financialReports.subtitle",
    "icon": "BarChart3",
    "minRole": "VIEWER",
    "firstLaunch": false
  },
  {
    "key": "accounting-exports",
    "route": "/accounting/exports",
    "label": "Accounting Exports",
    "labelKey": "menu.accountingExports.label",
    "subtitle": "Export posted journals as generic CSV",
    "subtitleKey": "menu.accountingExports.subtitle",
    "icon": "FileText",
    "minRole": "VIEWER",
    "firstLaunch": false
  },
  {
    "key": "bank-accounts",
    "route": "/banking/accounts",
    "label": "Account Settings",
    "labelKey": "menu.bankAccounts.label",
    "subtitle": "Manage bank accounts and GL mappings",
    "subtitleKey": "menu.bankAccounts.subtitle",
    "icon": "Wallet",
    "minRole": "VIEWER"
  },
  {
    "key": "bank-import",
    "route": "/banking/import",
    "label": "Bank Import",
    "labelKey": "menu.bankImport.label",
    "subtitle": "Upload bank statements and review import batches",
    "subtitleKey": "menu.bankImport.subtitle",
    "icon": "Landmark",
    "minRole": "VIEWER"
  },
  {
    "key": "bank-evidence",
    "route": "/banking/evidence",
    "label": "Bank Evidence Link",
    "labelKey": "menu.bankEvidence.label",
    "subtitle": "Link withdrawal lines to confirmed document segments",
    "subtitleKey": "menu.bankEvidence.subtitle",
    "icon": "FileSearch",
    "minRole": "VIEWER"
  },
  {
    "key": "bank-matching",
    "route": "/banking/matching",
    "label": "Bank Matching",
    "labelKey": "menu.bankMatching.label",
    "subtitle": "Match bank statement lines to candidates and confirm decisions",
    "subtitleKey": "menu.bankMatching.subtitle",
    "icon": "ArrowLeftRight",
    "minRole": "VIEWER",
    "firstLaunch": false
  },
  {
    "key": "bank-reconciliation",
    "route": "/banking/reconciliation",
    "label": "Period Reconciliation",
    "labelKey": "menu.bankReconciliation.label",
    "subtitle": "Review bank lines and business transactions by period",
    "subtitleKey": "menu.bankReconciliation.subtitle",
    "icon": "Scale",
    "minRole": "VIEWER",
    "firstLaunch": false
  },
  {
    "key": "ar-ap-receivables",
    "route": "/accounting/receivables",
    "label": "Receivables",
    "labelKey": "menu.arApReceivables.label",
    "subtitle": "Operational AR open items",
    "subtitleKey": "menu.arApReceivables.subtitle",
    "icon": "HandCoins",
    "minRole": "VIEWER",
    "firstLaunch": false
  },
  {
    "key": "ar-ap-payables",
    "route": "/accounting/payables",
    "label": "Payables",
    "labelKey": "menu.arApPayables.label",
    "subtitle": "Operational AP open items",
    "subtitleKey": "menu.arApPayables.subtitle",
    "icon": "Wallet",
    "minRole": "VIEWER",
    "firstLaunch": false
  },
  {
    "key": "ar-ap-payments",
    "route": "/accounting/payments",
    "label": "Payments",
    "labelKey": "menu.arApPayments.label",
    "subtitle": "Incoming and outgoing cash facts",
    "subtitleKey": "menu.arApPayments.subtitle",
    "icon": "Banknote",
    "minRole": "VIEWER",
    "firstLaunch": false
  },
  {
    "key": "ar-ap-opening-import",
    "route": "/accounting/opening-ar-ap",
    "label": "Opening AR/AP",
    "labelKey": "menu.openingArAp.label",
    "subtitle": "Import opening AR/AP balances",
    "subtitleKey": "menu.openingArAp.subtitle",
    "icon": "Upload",
    "minRole": "VIEWER",
    "firstLaunch": false
  },
  {
    "key": "japanese-financial-statements",
    "route": "/japanese-financial-statements",
    "label": "Japanese Financial Statements",
    "labelKey": "menu.japaneseFinancialStatements.label",
    "subtitle": "Japanese presentation financial statements from report snapshots",
    "subtitleKey": "menu.japaneseFinancialStatements.subtitle",
    "icon": "FileSpreadsheet",
    "minRole": "VIEWER",
    "firstLaunch": false
  },
  {
    "key": "webhooks",
    "route": "/webhooks",
    "label": "Webhook",
    "labelKey": "menu.webhooks.label",
    "subtitle": "Event delivery and integrations",
    "icon": "Webhook",
    "minRole": "VIEWER"
  },
  {
    "key": "team",
    "route": "/team",
    "label": "Access Management",
    "labelKey": "menu.team.label",
    "subtitle": "Menu permissions and members",
    "icon": "Users",
    "minRole": "VIEWER"
  },
  {
    "key": "organization-health",
    "route": "/organization",
    "label": "Organization Management",
    "labelKey": "menu.organizationHealth.label",
    "subtitle": "Company profile, offices, and departments",
    "subtitleKey": "menu.organizationHealth.subtitle",
    "icon": "Building2",
    "minRole": "VIEWER",
    "firstLaunch": false
  },
  {
    "key": "employee-management",
    "route": "/employees",
    "label": "Employee Management",
    "labelKey": "menu.employeeManagement.label",
    "subtitle": "Employees, retirees, and tags",
    "subtitleKey": "menu.employeeManagement.subtitle",
    "icon": "UsersRound",
    "minRole": "VIEWER",
    "firstLaunch": false
  },
  {
    "key": "feedback",
    "route": "/feedback",
    "label": "Feedback",
    "labelKey": "feedbackPage.title",
    "subtitle": "View feedback history and follow-ups",
    "subtitleKey": "menu.feedback.subtitle",
    "icon": "MessageSquare",
    "minRole": "VIEWER",
    "firstLaunch": false
  },
  {
    "key": "billing",
    "route": "/billing",
    "label": "Plan & Billing",
    "labelKey": "menu.billing.label",
    "subtitle": "Plan, quotas, and invoices",
    "icon": "CreditCard",
    "minRole": "VIEWER"
  },
  {
    "key": "settings",
    "route": "/settings",
    "label": "Settings",
    "labelKey": "menu.settings.label",
    "subtitle": "Account and security",
    "icon": "Settings",
    "minRole": "VIEWER"
  },
  {
    "key": "notifications",
    "route": "/notifications",
    "label": "Notifications",
    "labelKey": "menu.notifications.label",
    "subtitle": "In-app alerts and updates",
    "icon": "Bell",
    "minRole": "VIEWER"
  }
] as const;

export const PLATFORM_FEATURE_DEFINITIONS = [
  {
    "key": "apiKeys",
    "label": "API key management",
    "labelKey": "operatorFeatureChecklist.features.apiKeys",
    "minRole": "ADMIN"
  },
  {
    "key": "mfa",
    "label": "Multi-factor authentication",
    "labelKey": "operatorFeatureChecklist.features.mfa",
    "minRole": "ADMIN"
  },
  {
    "key": "dataExport",
    "label": "Data export",
    "labelKey": "operatorFeatureChecklist.features.dataExport",
    "minRole": "MANAGER"
  },
  {
    "key": "aiGateway",
    "label": "AI gateway access",
    "labelKey": "operatorFeatureChecklist.features.aiGateway",
    "minRole": "ADMIN"
  }
] as const;

export type PlatformMenuKey = (typeof PLATFORM_MENU_DEFINITIONS)[number]['key'];
export type PlatformFeatureKey = (typeof PLATFORM_FEATURE_DEFINITIONS)[number]['key'];

